// extracted by mini-css-extract-plugin
module.exports = {"social-menu-paper":"SocialMenu_social-menu-paper__3k_w8","social-menu-list":"SocialMenu_social-menu-list__38LE_","link-icon":"SocialMenu_link-icon__3qfkS"};